import axios from 'axios'
import cookie from 'js-cookie'
import queryString from 'query-string'

// 请求拦截器
axios.interceptors.request.use(
  (config) => {
    // Do something before request is sent
    // 管理员操作统一添加userId
    const userType = window._userType || (window.user && window.user.userType)
    if (userType === 'CARRIER') {
      const query = queryString.parse(location.search)
      const userId = window._userId || query.outUserId
      if (userId && config.data) {
        config.data.userId = userId
      }
    }

    return config
  },
  (err) => {
    // Do something with request error
    return Promise.reject(err)
  }
)


export default function (options) {

  return new Promise((resolve, reject) => {
    const method = options.method ? options.method.toLocaleUpperCase() : 'GET'

    if (method === 'POST') {
      options.data._csrf = cookie.get('csrfToken')
    }

    axios(options).then(response => {
      const { status, data: result } = response
      if (status === 200) {
        const { success, data, message, code} = result

        if (success) {
          resolve(data)
        } else {
          if (message) {
            if (message === '请登录') {
              location.href = `/login.html?done=${location.href}`
            }

            reject({
              ...result,
              status
            })
          } else {
            reject({
              ...result,
              status
            })
          }
        }
      } else {
        reject(new Error('网络异常，请稍后再试'))
      }
    }).catch(err => {
      reject(err)
    })
  })
}
